import Localization from 'lib/localization';

export default {
    lxTitle() {
        return Localization.get('badoo_homepage@forgot_password.page.title');
    },

    lxBody() {
        return Localization.get('badoo_homepage@forgot_password.page.body');
    },

    lxFieldLabel() {
        return Localization.get('badoo_homepage@forgot_password.page.field.label');
    },

    lxButtonSubmit() {
        return Localization.get('badoo_homepage@forgot_password.page.button_submit');
    },
};
